import { render, staticRenderFns } from "./CardBolao.vue?vue&type=template&id=4360a89d&scoped=true"
import script from "./CardBolao.vue?vue&type=script&lang=js"
export * from "./CardBolao.vue?vue&type=script&lang=js"
import style0 from "./CardBolao.scss?vue&type=style&index=0&id=4360a89d&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4360a89d",
  null
  
)

export default component.exports